import { ReportFeatures } from '@hcs/types';

export const NEARBY_CHART_FEATURES = [
  ReportFeatures.NearbyPropertiesChart,
  ReportFeatures.CompsNearbyFilteredCharts,
];
